export default __webpack_public_path__ + "static/media/StepsInactive04.ef68c45e.svg";